
// import React, { useState } from "react";
// import { Box, Typography, Button, TextField, Divider } from "@mui/material";
// import OTPInput from "../OTPinput";
// import Notification from "../Notification";
// import GlassLoaderOverLay from "../GlassLoader";
// import { useApi } from "../../api/useApi";
// import { useAuth } from "../../auth/AuthContext";
// import { useNavigate } from "react-router-dom";
// import ContactUsPopup from "../ContactusPage";
// export default function LoginFormContent({
//   isLogin,
//   onSwitchToLogin,
//   onSwitchToSignup,
// }) {
//   const { login } = useAuth();
//   const { request, loading } = useApi();
//   const navigate = useNavigate();

//   const [email, setEmail] = useState("");
//   const [otp, setOtp] = useState("");
//   const [showOtpInput, setShowOtpInput] = useState(false);
//   const [otpSent, setOtpSent] = useState(false);
//   const [open, setOpen] = useState(false)
//   const [notif, setNotif] = useState({
//     open: false,
//     success: true,
//     text: "",
//   });

//   const CheckIcon = () => (
//     <img
//       src="/icons/check.svg"
//       alt="success"
//       style={{ width: "14px", height: "14px" }}
//     />
//   );

//   // ---------------------------
//   // SEND OTP
//   // ---------------------------
//   const handleSendOtp = async () => {
//     if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
//       return setNotif({
//         open: true,
//         success: false,
//         text: "Enter a valid email before sending OTP",
//       });
//     }

//     try {
//       const existsRes = await request({
//         url: "/user/exists",
//         method: "GET",
//         params: { email },
//       });

//       if (!existsRes.exists) {
//         return setNotif({
//           open: true,
//           success: false,
//           text: "You don't have an account. Please Sign Up.",
//         });
//       }

//       await request({
//         url: "/user/send-otp",
//         method: "GET",
//         params: { email },
//       });

//       setOtpSent(true);
//       setShowOtpInput(true);

//       setNotif({
//         open: true,
//         success: true,
//         text: "OTP has been sent successfully to your registered email.",
//       });
//     } catch (err) {
//       console.error(err);
//       setNotif({
//         open: true,
//         success: false,
//         text: err,
//       });
//     }
//   };

//   const handleLogin = async () => {
//     if (!otp || otp.length !== 6) {
//       return setNotif({
//         open: true,
//         success: false,
//         text: "Please enter OTP completely.",
//       });
//     }

//     try {
//       const [verifyOtp, users] = await Promise.all([
//         request({
//           url: "/user/verify-otp",
//           method: "GET",
//           params: { email, otp },
//         }),
//         request({
//           url: `/user/by-email`,
//           method: "GET",
//           params: { email },
//         }),
//       ]);

//       if (!verifyOtp) {
//         return setNotif({
//           open: true,
//           success: false,
//           text: "OTP verification failed.",
//         });
//       }

//       const user = users.filter((u) => u.emailId === email)[0];
//       login({
//         name: user.userName,
//         email: user.emailId,
//         domain: user.domain,
//       });

//       // window.location.href = `/questions/${user.domain}`;
//       navigate(`/questions/${user.domain === "" ? null : user.domain}`)
//     } catch (err) {
//       console.error(err);
//       setNotif({
//         open: true,
//         success: false,
//         text: "Login failed. Try again.",
//       });
//     }
//   };

//   const handleOtpPaste = (e) => {
//     e.preventDefault();
//     const pasted = e.clipboardData.getData("text").trim();

//     if (/^\d+$/.test(pasted)) {
//       const firstSix = pasted.slice(0, 6); // limit to 6 digits
//       setOtp(firstSix);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         width: {
//           xs: "90%",
//           sm: "90%",
//           md: "80%",
//           lg: "95%",
//           xl: "80%",
//         },
//         display: "flex",
//         flexDirection: "column",
//         gap: 3, // ⭐ uniform spacing for EVERYTHING
//       }}
//     >
//       {/* TITLE */}
//       <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//         <Typography
//           sx={{
//             color: "#0036DD",
//             fontFamily: "Akkurat-Bold",
//             fontSize: {
//               xs: "1rem",
//               sm: "1rem",
//               md: "1rem",
//               lg: "18px",
//               xl: "20px",
//             },
//           }}
//         >
//           DevOps and SRE Compass

//         </Typography>

//         <Typography
//           sx={{
//             color: "#525252",
//             fontFamily: "Akkurat-Pro",
//             fontWeight: 400,
//             fontSize: {
//               xs: "0.7rem",
//               sm: "0.7rem",
//               md: "0.7rem",
//               lg: "12px",
//               xl: "0.8rem",
//             },
//           }}
//         >
//           Log in to access your DevOps and SRE maturity!
//         </Typography>
//       </Box>

//       {/* TOGGLE BUTTON */}
//       <Box
//         sx={{
//           display: "flex",
//           height: "2rem",
//           borderRadius: "1.75rem",
//           border: "1px solid #E0E0E0",
//           background: "#FFF",
//           // mb: { xs: 3, sm: 3, md: 3, lg: 3, xl: 4 },
//           flexShrink: 0,
//         }}
//       >
//         {/* LOGIN */}
//         <Box
//           onClick={onSwitchToLogin}
//           sx={{
//             flex: 1,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             borderRadius: "1.75rem",
//             background: isLogin ? "#D5DBDE" : "transparent",
//             color: "#34044",
//             fontWeight: "400",
//             cursor: "pointer",
//             fontFamily: isLogin ? "Akkurat-Bold" : "Akkurat-Pro",
//             transition: "0.2s",
//             fontSize: "0.8rem",
//           }}
//         >
//           Login
//         </Box>

//         {/* SIGN UP */}
//         <Box
//           onClick={onSwitchToSignup}
//           sx={{
//             flex: 1,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             borderRadius: "1.75rem",
//             background: !isLogin ? "#D5DBDE" : "transparent",
//             color: "#34044",
//             cursor: "pointer",
//             transition: "0.2s",
//             fontSize: "0.8rem",
//             fontFamily: "Akkurat-Pro",
//           }}
//         >
//           Sign Up
//         </Box>
//       </Box>

//       {/* EMAIL FIELD */}
//       <form
//         onSubmit={(e) => {
//           e.preventDefault();

//           if (email) {
//             handleSendOtp();
//           }
//         }}
//       >
//         <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//           <Typography
//             sx={{
//               color: "#525252",
//               fontSize: {
//                 xs: "0.8rem",
//                 sm: "0.8rem",
//                 md: "0.8rem",
//                 lg: "0.75rem",
//                 xl: "1rem",
//               },
//               fontFamily: "Akkurat-Pro",
//             }}
//           >
//             Business email*
//           </Typography>
//           <Box
//             sx={{
//               borderRadius: "1.75rem",
//               border: "1px solid #E0E0E0",
//               pl: 1,
//               height: "35px",
//               width: "98%",
//               display: "flex",
//               alignItems: "center",
//             }}
//           >
//             <TextField
//               variant="standard"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               placeholder="i.e. john.doe@sandhata.com"
//               slotProps={{ input: { disableUnderline: true } }}
//               sx={{
//                 width: "100%",
//                 "& input": {
//                   fontSize: "0.72rem",
//                   fontFamily: "Akkurat-Pro",
//                 },
//                 /* REMOVE CHROME AUTOFILL BLUE BACKGROUND */
//                 "& input:-webkit-autofill": {
//                   WebkitBoxShadow: "0 0 0 1000px white inset !important",
//                   WebkitTextFillColor: "#000 !important",
//                   caretColor: "#000",
//                 },
//               }}
//             />
//           </Box>
//         </Box>

//         {/* SEND OTP */}
//         <Button
//           onClick={handleSendOtp}
//           disableRipple
//           disabled={!email || !/^\S+@\S+\.\S+$/.test(email) || otpSent}
//           sx={{
//             width: "180px",
//             height: "36px",
//             fontSize: "0.8rem",
//             borderRadius: "1.75rem",
//             textTransform: "none",
//             fontFamily: "Akkurat-Pro",
//             fontWeight: "400",
//             // fontSize: "12px",
//             marginTop: '12px',
//             background:
//               !email || !/^\S+@\S+\.\S+$/.test(email) || otpSent
//                 ? "#F5F6F8"
//                 : "#0036DD",
//             color:
//               !email || !/^\S+@\S+\.\S+$/.test(email) || otpSent
//                 ? "#A3A3A3"
//                 : "#FFF",
//             "&:hover": {
//               background:
//                 !email || !/^\S+@\S+\.\S+$/.test(email) || otpSent
//                   ? "#F5F6F8"
//                   : "#0030C2",
//             },
//           }}
//         >
//           {otpSent ? "OTP sent" : "Send OTP"}
//         </Button>

//         {/* OTP SECTION */}
//         {showOtpInput && (
//           <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//             <Typography
//               sx={{
//                 color: "#525252",
//                 fontSize: {
//                   xs: "0.8rem",
//                   sm: "0.8rem",
//                   md: "0.8rem",
//                   lg: "0.75rem",
//                   xl: "1rem",
//                 },
//                 fontFamily: "Akkurat-Pro",
//               }}
//             >
//               Enter OTP*
//             </Typography>

//             <Box sx={{ display: "flex", gap: 1 }}>
//               <Box
//                 sx={{ display: "flex", justifyContent: "left" }}
//                 onPaste={handleOtpPaste} // ✅ paste works on any input
//               >
//                 <OTPInput
//                   value={otp}
//                   onChange={setOtp}
//                   numInputs={6}
//                   shouldAutoFocus
//                   inputStyle={{
//                     width: "2.2rem",
//                     height: "2.5rem",
//                     borderRadius: "0.6rem",
//                     border: "1px solid #000",
//                     textAlign: "center",
//                     fontSize: "1rem",
//                   }}
//                 />
//               </Box>
//             </Box>
//             <Typography
//               onClick={() => {
//                 setOtp("");
//                 handleSendOtp();
//               }}
//               sx={{
//                 color: "#0036DD",
//                 textDecoration: "underline",
//                 cursor: "pointer",
//                 fontSize: "0.65rem",
//                 fontFamily: "Akkurat-Pro",
//               }}
//             >
//               Resend OTP
//             </Typography>

//             <Button
//               onClick={handleLogin}
//               disableRipple
//               sx={{
//                 width: "11.5rem",
//                 height: "2.25rem",
//                 fontSize: "0.8rem",
//                 borderRadius: "1.75rem",
//                 background: otp.length === 6 ? "#0036DD" : "#F5F6F8",
//                 color: otp.length === 6 ? "#FFF" : "#c8c8c9ff",
//                 textTransform: "none",
//                 fontFamily: "Akkurat-Pro",
//               }}
//             >
//               Start Assessment
//             </Button>
//           </Box>
//         )}
//       </form>

//       <Divider />

//       {/* HELP SECTION */}
//       <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//         <Typography
//           sx={{
//             fontSize: {
//               xs: "0.7rem",
//               sm: "0.7rem",
//               md: "0.7rem",
//               lg: "0.875rem",
//               xl: "0.9rem",
//             },
//             color: "#525252",
//             fontFamily: "Akkurat-Bold",
//             fontWeight: 400,
//           }}
//         >
//           Got a query?
//         </Typography>

//         <Typography
//           sx={{
//             fontSize: {
//               xs: "0.7rem",
//               sm: "0.7rem",
//               md: "0.7rem",
//               lg: "0.75rem",
//               xl: "0.9rem",
//             },
//             color: "#939292ff",
//             fontFamily: "Akkurat-Pro",
//             fontWeight: 400,
//           }}
//         >
//           We're here to help! Please complete the{" "}
//           <Box
//             component="span"
//             sx={{
//               color: "#0036DD",
//               textDecoration: "underline",
//               cursor: "pointer",
//               fontFamily: "Akkurat-Pro",
//               "&:hover": { opacity: 0.8 },
//             }}
//             onClick={async () => {
//               // if (!email) {
//               //   setNotif({
//               //     open: true,
//               //     success: false,
//               //     text: "Please enter your email to continue.",
//               //   });
//               //   return;
//               // }

//               // navigate("/contactus-page", {
//               //   state: {
//               //     email: email,
//               //     userLogedIn: false,
//               //   },
//               // });
//               setOpen(true)
//             }}
//           >
//             Contact Us
//           </Box>
//           <br />
//           and our executives will connect with you shortly.
//         </Typography>
//       </Box>
//       <ContactUsPopup
//         open={open}
//         onClose={() => setOpen(false)}
//         prefillData={{
//           name: '',
//           email: email ? email : '',
//           phone: '',
//         }}
//       />

//       <Notification
//         open={notif.open}
//         success={notif.success}
//         text={notif.text}
//         onClose={() => setNotif((prev) => ({ ...prev, open: false }))}
//       />

//       <GlassLoaderOverLay open={loading} />
//     </Box>
//   );
// }



import React, { useState } from "react";
import { Box, Typography, Button, TextField, Divider } from "@mui/material";
import OTPInput from "../OTPinput";
import Notification from "../Notification";
import GlassLoaderOverLay from "../GlassLoader";
import { useApi } from "../../api/useApi";
import { useAuth } from "../../auth/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import ContactUsPopup from "../ContactusPage";
export default function LoginFormContent({
  isLogin,
  onSwitchToLogin,
  onSwitchToSignup,
}) {
  const { login } = useAuth();
  const { request, loading } = useApi();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [open, setOpen] = useState(false)
  const [notif, setNotif] = useState({
    open: false,
    success: true,
    text: "",
  });

  const CheckIcon = () => (
    <img
      src="/icons/check.svg"
      alt="success"
      style={{ width: "14px", height: "14px" }}
    />
  );

  // ---------------------------
  // SEND OTP
  // ---------------------------
  const handleSendOtp = async () => {
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      return setNotif({
        open: true,
        success: false,
        text: "Enter a valid email before sending OTP",
      });
    }

    try {
      const existsRes = await request({
        url: "/user/exists",
        method: "GET",
        params: { email },
      });

      if (!existsRes.exists) {
        return setNotif({
          open: true,
          success: false,
          text: "You don't have an account. Please Sign Up.",
        });
      }

      await request({
        url: "/user/send-otp",
        method: "GET",
        params: { email },
      });

      setOtpSent(true);
      setShowOtpInput(true);

      setNotif({
        open: true,
        success: true,
        text: "OTP has been sent successfully to your registered email.",
      });
    } catch (err) {
      console.error(err);
      setNotif({
        open: true,
        success: false,
        text: err,
      });
    }
  };

  const handleLogin = async () => {
    if (!otp || otp.length !== 6) {
      return setNotif({
        open: true,
        success: false,
        text: "Please enter OTP completely.",
      });
    }

    try {
      const [verifyOtp, users] = await Promise.all([
        request({
          url: "/user/verify-otp",
          method: "GET",
          params: { email, otp },
        }),
        request({
          url: `/user/by-email`,
          method: "GET",
          params: { email },
        }),
      ]);

      if (!verifyOtp) {
        return setNotif({
          open: true,
          success: false,
          text: "OTP verification failed.",
        });
      }

      const user = users.filter((u) => u.emailId === email)[0];
      login({
        name: user.userName,
        email: user.emailId,
        domain: user.domain,
      });

      // window.location.href = `/questions/${user.domain}`;
      const from = location.state?.from;
      if (from) {
        navigate(`${from.pathname}${from.search || ""}`);
      } else if (user.domain) {
        navigate(`/questions/${user.domain}`);
      } else {
        navigate("/landing-page");
      }
    } catch (err) {
      console.error(err);
      setNotif({
        open: true,
        success: false,
        text: "Login failed. Try again.",
      });
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").trim();

    if (/^\d+$/.test(pasted)) {
      const firstSix = pasted.slice(0, 6); // limit to 6 digits
      setOtp(firstSix);
    }
  };

  return (
    <Box
      sx={{
        width: {
          xs: "90%",
          sm: "90%",
          md: "80%",
          lg: "95%",
          xl: "80%",
        },
        display: "flex",
        flexDirection: "column",
        gap: 3, // ⭐ uniform spacing for EVERYTHING
      }}
    >
      {/* TITLE */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Typography
          sx={{
            color: "#0036DD",
            fontFamily: "Akkurat-Bold",
            fontSize: {
              xs: "1rem",
              sm: "1rem",
              md: "1rem",
              lg: "18px",
              xl: "20px",
            },
          }}
        >
          DevOps and SRE Compass

        </Typography>

        <Typography
          sx={{
            color: "#525252",
            fontFamily: "Akkurat-Pro",
            fontWeight: 400,
            fontSize: {
              xs: "0.7rem",
              sm: "0.7rem",
              md: "0.7rem",
              lg: "12px",
              xl: "0.8rem",
            },
          }}
        >
          Log in to access your DevOps and SRE maturity!
        </Typography>
      </Box>

      {/* TOGGLE BUTTON */}
      <Box
        sx={{
          display: "flex",
          height: "2rem",
          borderRadius: "1.75rem",
          border: "1px solid #E0E0E0",
          background: "#FFF",
          // mb: { xs: 3, sm: 3, md: 3, lg: 3, xl: 4 },
          flexShrink: 0,
        }}
      >
        {/* LOGIN */}
        <Box
          onClick={onSwitchToLogin}
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "1.75rem",
            background: isLogin ? "#D5DBDE" : "transparent",
            color: "#34044",
            fontWeight: "400",
            cursor: "pointer",
            fontFamily: isLogin ? "Akkurat-Bold" : "Akkurat-Pro",
            transition: "0.2s",
            fontSize: "0.8rem",
          }}
        >
          Login
        </Box>

        {/* SIGN UP */}
        <Box
          onClick={onSwitchToSignup}
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "1.75rem",
            background: !isLogin ? "#D5DBDE" : "transparent",
            color: "#34044",
            cursor: "pointer",
            transition: "0.2s",
            fontSize: "0.8rem",
            fontFamily: "Akkurat-Pro",
          }}
        >
          Sign Up
        </Box>
      </Box>

      {/* EMAIL FIELD */}
      <form
        onSubmit={(e) => {
          e.preventDefault();

          if (email) {
            handleSendOtp();
          }
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography
            sx={{
              color: "#525252",
              fontSize: {
                xs: "0.8rem",
                sm: "0.8rem",
                md: "0.8rem",
                lg: "0.75rem",
                xl: "1rem",
              },
              fontFamily: "Akkurat-Pro",
            }}
          >
            Business email*
          </Typography>
          <Box
            sx={{
              borderRadius: "1.75rem",
              border: "1px solid #E0E0E0",
              pl: 1,
              height: "35px",
              width: "98%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <TextField
              variant="standard"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="i.e. john.doe@sandhata.com"
              slotProps={{ input: { disableUnderline: true } }}
              sx={{
                width: "100%",
                "& input": {
                  fontSize: "0.72rem",
                  fontFamily: "Akkurat-Pro",
                },
                /* REMOVE CHROME AUTOFILL BLUE BACKGROUND */
                "& input:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px white inset !important",
                  WebkitTextFillColor: "#000 !important",
                  caretColor: "#000",
                },
              }}
            />
          </Box>
        </Box>

        {/* SEND OTP */}
        <Button
          onClick={handleSendOtp}
          disableRipple
          disabled={!email || !/^\S+@\S+\.\S+$/.test(email) || otpSent}
          sx={{
            width: "180px",
            height: "36px",
            fontSize: "0.8rem",
            borderRadius: "1.75rem",
            textTransform: "none",
            fontFamily: "Akkurat-Pro",
            fontWeight: "400",
            // fontSize: "12px",
            marginTop: '12px',
            background:
              !email || !/^\S+@\S+\.\S+$/.test(email) || otpSent
                ? "#F5F6F8"
                : "#0036DD",
            color:
              !email || !/^\S+@\S+\.\S+$/.test(email) || otpSent
                ? "#A3A3A3"
                : "#FFF",
            "&:hover": {
              background:
                !email || !/^\S+@\S+\.\S+$/.test(email) || otpSent
                  ? "#F5F6F8"
                  : "#0030C2",
            },
          }}
        >
          {otpSent ? "OTP sent" : "Send OTP"}
        </Button>

        {/* OTP SECTION */}
        {showOtpInput && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography
              sx={{
                color: "#525252",
                fontSize: {
                  xs: "0.8rem",
                  sm: "0.8rem",
                  md: "0.8rem",
                  lg: "0.75rem",
                  xl: "1rem",
                },
                fontFamily: "Akkurat-Pro",
              }}
            >
              Enter OTP*
            </Typography>

            <Box sx={{ display: "flex", gap: 1 }}>
              <Box
                sx={{ display: "flex", justifyContent: "left" }}
                onPaste={handleOtpPaste} // ✅ paste works on any input
              >
                <OTPInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  shouldAutoFocus
                  inputStyle={{
                    width: "2.2rem",
                    height: "2.5rem",
                    borderRadius: "0.6rem",
                    border: "1px solid #000",
                    textAlign: "center",
                    fontSize: "1rem",
                  }}
                />
              </Box>
            </Box>
            <Typography
              onClick={() => {
                setOtp("");
                handleSendOtp();
              }}
              sx={{
                color: "#0036DD",
                textDecoration: "underline",
                cursor: "pointer",
                fontSize: "0.65rem",
                fontFamily: "Akkurat-Pro",
              }}
            >
              Resend OTP
            </Typography>

            <Button
              onClick={handleLogin}
              disableRipple
              sx={{
                width: "11.5rem",
                height: "2.25rem",
                fontSize: "0.8rem",
                borderRadius: "1.75rem",
                background: otp.length === 6 ? "#0036DD" : "#F5F6F8",
                color: otp.length === 6 ? "#FFF" : "#c8c8c9ff",
                textTransform: "none",
                fontFamily: "Akkurat-Pro",
              }}
            >
              Start Assessment
            </Button>
          </Box>
        )}
      </form>

      <Divider />

      {/* HELP SECTION */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Typography
          sx={{
            fontSize: {
              xs: "0.7rem",
              sm: "0.7rem",
              md: "0.7rem",
              lg: "0.875rem",
              xl: "0.9rem",
            },
            color: "#525252",
            fontFamily: "Akkurat-Bold",
            fontWeight: 400,
          }}
        >
          Got a query?
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: "0.7rem",
              sm: "0.7rem",
              md: "0.7rem",
              lg: "0.75rem",
              xl: "0.9rem",
            },
            color: "#939292ff",
            fontFamily: "Akkurat-Pro",
            fontWeight: 400,
          }}
        >
          We're here to help! Please complete the{" "}
          <Box
            component="span"
            sx={{
              color: "#0036DD",
              textDecoration: "underline",
              cursor: "pointer",
              fontFamily: "Akkurat-Pro",
              "&:hover": { opacity: 0.8 },
            }}
            onClick={async () => {
              // if (!email) {
              //   setNotif({
              //     open: true,
              //     success: false,
              //     text: "Please enter your email to continue.",
              //   });
              //   return;
              // }

              // navigate("/contactus-page", {
              //   state: {
              //     email: email,
              //     userLogedIn: false,
              //   },
              // });
              setOpen(true)
            }}
          >
            Contact Us
          </Box>
          <br />
          and our executives will connect with you shortly.
        </Typography>
      </Box>
      <ContactUsPopup
        open={open}
        onClose={() => setOpen(false)}
        prefillData={{
          name: '',
          email: email ? email : '',
          phone: '',
        }}
      />

      <Notification
        open={notif.open}
        success={notif.success}
        text={notif.text}
        onClose={() => setNotif((prev) => ({ ...prev, open: false }))}
      />

      <GlassLoaderOverLay open={loading} />
    </Box>
  );
}